/*
 * @providesModule VerifyPasswordModal
 * 
 */

import React from 'react';

import {_m} from 'INTL';
import AccountInfoModal from 'AccountInfoModal';
import CurrentUserStore from 'CurrentUserStore';
import PropTypes from 'prop-types';
import LoadingIndicator from 'LoadingIndicator';

import {
  NativeModules,
  TextInput,
  StyleSheet,
} from 'react-native';

const SkillzModule = NativeModules.SkillzModule;

const TEST_IDS = {
  PASSWORD_TEXT_INPUT: 'password_text_input',
};

export default
class VerifyPasswordModal extends React.Component {

  static propTypes = {
    onDone: PropTypes.func,
    onCancel: PropTypes.func,
    bodyText: PropTypes.string,
  }

  constructor(props: Object) {
    super(props);
    this.state = {
      text: '',
    };

    this._isSuccess = false;
  }

  onChangeText = (text: string) => {
    this.setState({text: text});
  };

  onDone = () => {
    LoadingIndicator.show();
    CurrentUserStore.fetchUser(true).then((userInfo: Object) => {
      if (userInfo.username) {
        SkillzModule.verifyUserWithPassword(userInfo.username, this.state.text, (error: Object, success: boolean) => {
          if (error) {
            LoadingIndicator.hide();
            this.setState({authenticationFailed: true});
          } else {
            if (this.state.authenticationFailed) {
              this.setState({authenticationFailed: false});
            }
            LoadingIndicator.hide();
            this.props.onDone(true);
          }
        });
      } else {
        LoadingIndicator.hide();
      }
    });
  }

  onCancel = () => {
    this.props.onCancel(false);
  }

  _onSubmitEditing = (event: Object) => {
    this.setState({text: event.nativeEvent.text});
  }

  _renderModalBody(): React.ReactNode {
    return (
      <TextInput style={styles.textInput}
                 secureTextEntry={true}
                 placeholder={_m('Password')}
                 underlineColorAndroid={'transparent'}
                 onChangeText={this.onChangeText}
                 onSubmitEditing={this._onSubmitEditing}
                 value={this.state.text}
                 accessible={true}
                 autoCapitalize={'none'}
                 accessibilityLabel={'password_field'}
                 testID={TEST_IDS.PASSWORD_TEXT_INPUT} />
    );
  }

  render(): React.ReactNode {
    const body = this._renderModalBody();
    const bodyText = this.state.authenticationFailed ? _m('Incorrect password. Please try again.') : this.props.bodyText;
    const authenticationStyle = this.state.authenticationFailed ? styles.errorText : {};

    return (
      <AccountInfoModal titleText={_m('Verify Password')}
                        bodyText={bodyText}
                        bodyStyle={[styles.body, authenticationStyle]}
                        bodyContents={body}
                        onDone={this.onDone}
                        onCancel={this.onCancel}
                        okButtonTitle={_m('Next')} />
    );
  }
}

const styles = StyleSheet.create({
  textInput: {
    height: 40,
    color: '#444',
    borderColor: 'gray',
    borderBottomWidth: 1,
    marginHorizontal: 61,
  },

  errorText: {
    color: 'rgb(188, 33, 49)',
  },

  body: {
    marginHorizontal: 25,
  },
});
